<template>
    <d-card-body>
        <d-list-group flush>
            <d-form>
                <h3 class="mt-2 mb-4">Edycja sprawy</h3>
            </d-form>
            <div v-if="!fetched" style="min-height: 500px;">
                <h2 class="preloader isLoading">Trwa ładowanie</h2>
            </div>
            <transition name="fade">
                <div v-if="fetched">
                    <d-row>
                        <d-col>
                            <d-card class="mb-3">
                                <d-card-header class="border-bottom">
                                    <h5 class="mb-0"><i class="material-icons">list</i> Szczegóły sprawy</h5>
                                </d-card-header>
                                <d-card-body>
                                    <d-row>
                                        <d-col>
                                            <div class="mb-3">
                                                <div class="inline-data-row mb-1"><strong class="font-weight-bold mr-2">Data nadania wniosku do komornika:</strong> <span>{{ execution.send_date }}</span><br /></div>
                                                <div class="inline-data-row mb-1"><strong class="font-weight-bold mr-2">Numer listu przewozowego:</strong> <ss-input name="consignment_number" placeholder="Numer listu przewozowego" v-model="execution.consignment_number" /></div>
                                                <div class="inline-data-row mb-1"><strong class="font-weight-bold mr-2">Data nadania klauzuli:</strong> <ss-date v-model="execution.release_date"></ss-date></div>
                                            </div>
                                        </d-col>
                                        <d-col>
                                            <div class="mb-3">
                                                <div class="inline-data-row mb-1"><strong class="font-weight-bold mr-2">Wypłacono komornikowi:</strong> <span>{{ execution.payments_sum }} zł</span></div>
                                                <div class="inline-data-row mb-1"><strong class="font-weight-bold mr-2">Wpłaty pozyskane ze spraw:</strong> <span>{{ execution.contributions_sum }} zł</span></div>
                                                <div class="inline-data-row mb-1"><strong class="font-weight-bold mr-2">Data odbioru wniosku przez komornika:</strong> <ss-date v-model="execution.receipt_date"></ss-date></div>
                                            </div>
                                        </d-col>
                                    </d-row>
                                </d-card-body>
                                <d-card-footer class="border-top d-flex justify-content-end">
                                    <d-button href="#" @click.prevent="submitForm" :class="{'isDisabled' : submitting_form}" theme="success" class="btn"><i class="fa fa-save mr-1"></i> Zapisz</d-button>
                                </d-card-footer>
                            </d-card>
                        </d-col>
                    </d-row>
                    <d-row class="align-items-stretch">
                        <d-col md="6" class="mb-3 h">
                            <d-card class="h-100">
                                <d-card-header class="border-bottom">
                                    <h5 class="mb-0"><i class="material-icons">person</i> Dłużnik</h5>
                                </d-card-header>
                                <d-card-body>
                                    <div v-if="execution.guarantor_id">
                                        <div>
                                            {{ execution.guarantor.name }} {{ execution.guarantor.surname }}<br />
                                            {{ execution.guarantor.street }} {{ execution.guarantor.house_number }}<br />
                                            {{ execution.guarantor.postcode }} {{ execution.guarantor.city }}<br />
                                            NIP: {{ execution.guarantor.nip}}<br />
                                            PESEL: {{ execution.guarantor.pesel}}
                                        </div>
                                        <div class="contact-info mt-2">
                                            <a :href="'tel:' + execution.guarantor.phone" class="d-flex mb-1 align-items-center" v-if="execution.guarantor.phone">
                                                <i class="fa fa-phone nr-2"></i> <span>{{ execution.guarantor.phone }}</span>
                                            </a>
                                            <a :href="'mailto:' + execution.guarantor.email" class="d-flex mb-1 align-items-center" v-if="execution.guarantor.email">
                                                <i class="fa fa-envelope mr-2"></i> <span>{{ execution.guarantor.email }}</span>
                                            </a>
                                        </div>
                                    </div>
                                    <div v-if="execution.guarantor_id == 0">
                                        <div v-if="client.type.toString() === 'corporation'">
                                            {{ client.company_name }}<br />
                                            {{ client.business_street }} {{ client.business_house_number }}{{ client.business_flat_number ? '/' + client.business_flat_number : '' }}<br />
                                            {{ client.business_postcode }} {{ client.business_city }}<br />
                                            NIP: {{ client.nip}}<br />
                                        </div>
                                        <div v-else>
                                            {{ client.name }}{{client.second_name ? ' ' + client.second_name : '' }} {{ client.surname }}<br />
                                            {{ client.correspondence_street }} {{ client.correspondence_house_number }}{{ client.correspondence_house_number ? '/' + client.correspondence_house_number : '' }}<br />
                                            {{ client.correspondence_postcode }} {{ client.correspondence_city }}<br />
                                            NIP: {{ client.nip}}<br />
                                            PESEL: {{ client.pesel}}
                                        </div>
                                        <div class="contact-info mt-2">
                                            <a :href="'tel:' + client.phone" class="d-flex mb-1 align-items-center" v-if="client.phone">
                                                <i class="fa fa-phone mr-2"></i> <span>{{ client.phone }}</span>
                                            </a>
                                            <a :href="'mailto:' + client.email" class="d-flex mb-1 align-items-center" v-if="client.email">
                                                <i class="fa fa-envelope mr-2"></i> <span>{{ client.email }}</span>
                                            </a>
                                            <a :href="'mailto:' + client.second_email" class="d-flex mb-1 align-items-center" v-if="client.second_email">
                                                <i class="fa fa-envelope mr-2"></i> <span>{{ client.second_email }}</span>
                                            </a>
                                        </div>

                                    </div>
                                </d-card-body>
                                <d-card-footer class="border-top d-flex justify-content-end">
                                    <a class="btn btn-primary" :href="$router.resolve({name: 'client-edit', params: {id: client.id}}).href" target="_blank"><i class="fa fa-eye mr-1"></i> Edytuj klienta</a>
                                </d-card-footer>
                            </d-card>
                        </d-col>
                        <d-col md="6" class="mb-3">
                            <d-card class="h-100">
                                <d-card-header class="border-bottom">
                                    <h5 class="mb-0"><i class="material-icons">person</i> Komornik</h5>
                                </d-card-header>
                                <d-card-body>
                                    <div class="bailiff" v-if="execution.bailiff && execution.bailiff.name">
                                        <div class="mb-3">
                                            {{ execution.bailiff.name }}<br />
                                            {{ execution.bailiff.bailiff_office_name }}<br />
                                            {{ execution.bailiff.bailiff_office_address }}<br />
                                            {{ execution.bailiff.bailiff_office_post_code }} {{ execution.bailiff.bailiff_office_city }}<br />
                                        </div>
                                        <div class="contact-info">
                                            <a :href="'mailto:' + execution.bailiff.mail" class="d-flex mb-1 align-items-center" v-if="execution.bailiff.email">
                                                <i class="fa fa-envelope mr-2"></i> <span>{{ execution.bailiff.email }}</span>
                                            </a>
                                            <a :href="'tel:' + execution.bailiff.phone" class="d-flex mb-1 align-items-center" v-if="execution.bailiff.phone">
                                                <i class="fa fa-phone mr-2"></i> <span>{{ execution.bailiff.phone }}</span>
                                            </a>
                                            <d-button theme="primary" class="mt-2" @click.prevent="telephonesModal = true"><i class="fa fa-phone mr-1"></i> Dodatkowe numery ({{execution.bailiff.telephones.length}})</d-button>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <p>Przypisany komornik nie istnieje, wybierz nowego.</p>
                                        <fieldset class="form-group">
                                            <label>Wybierz komornika z listy</label>
                                            <div class="d-flex" :class="{'is-invalid' : lar_errors.has('bailiff_id') }">
                                                <v-select
                                                        class="w-100"
                                                        :options="allBailiffs"
                                                        v-model="execution.bailiff_id"
                                                        @input="lar_errors.clear('bailiff_id')"
                                                        :reduce="bailiff => bailiff.id"
                                                        placeholder="Wpisz dane komornika..."
                                                                        label="name">
                                                <span slot="no-options">
                                                  Brak wyników
                                                </span>
                                                </v-select>
                                                <d-button class="wsnw ml-4" @click.prevent="newBailiffModal = true">Dodaj komornika</d-button>
                                            </div>
                                            <div class="invalid-feedback" :class="{'d-block': lar_errors.get('bailiff_id')}" v-text="lar_errors.get('bailiff_id')"></div>
                                        </fieldset>
                                    </div>
                                </d-card-body>
                                <d-card-footer class="border-top d-flex justify-content-end">
                                    <a class="btn btn-primary" :href="$router.resolve({name: 'bailiff-edit', params: {id: bailiff.id}}).href" v-if="bailiff && execution.bailiff.name" target="_blank"><i class="fa fa-eye mr-1"></i> Edytuj komornika</a>
                                    <d-button @click.prevent="submitForm" v-else  theme="success" class="btn"><i class="fa fa-save mr-1"></i> Zapisz</d-button>
                                </d-card-footer>
                            </d-card>
                        </d-col>
                    </d-row>


                    <d-row>
                        <d-col md="6" class="mb-3">
                            <h5 class="mt-5">Weryfikacja załatwionych czynności: {{ completeApplications(execution.applications) }}/{{ execution.applications.length }}</h5>
                            <div v-for="application in execution.applications">
                                <d-checkbox value="1" unchecked-value="0" v-model="application.status" @input="applicationStatusChanged(application)">{{ application.application_name }}</d-checkbox>
                            </div>
                        </d-col>
                        <d-col md="6" class="mb-3">
                            <fieldset class="form-group">
                                <h5 class="mt-5">Zaznacz nowe czynności jakimi ma się zająć komornik:</h5>
                                <div v-for="application in allApplications" v-if="!execution.applications.find(item => item.case_application_id === application.id)">
                                    <d-checkbox :value="application" v-model="execution.applications">{{ application.name }}</d-checkbox>
                                </div>
                                <d-checkbox v-model="other_applications">Inne</d-checkbox>
                                <template v-if="other_applications">
                                    <div class="d-flex" @keyup.enter="addNewApplication">
                                        <d-input ref="newApplicationInput" v-model="new_application"></d-input>
                                        <d-button class="wsnw" @click.prevent="addNewApplication">Dodaj do listy</d-button>
                                    </div>
                                    <div class="d-flex justify-content-between mt-3 mb-0" v-for="(new_app, index) in execution.new_applications" :key="'new_app-' + index">
                                        <span>{{ new_app}}</span><a href="#" class="badge-danger badge text-white" @click.prevent="removeNewApplication(index)"><i class="material-icons">delete</i></a>
                                    </div>
                                </template>
                                <d-button href="#" @click.prevent="submitForm" :class="{'isDisabled' : submitting_form}" theme="success" class="btn mt-2"><i class="fa fa-save mr-1"></i> Zapisz</d-button>
                            </fieldset>
                        </d-col>
                    </d-row>

                    <h5 class="mt-4">Komentarze do załatwionych czynności</h5>
                    <div class="accordion-wrapper mb-2" v-for="(application, index) in execution.applications">
                        <d-card-header class="px-3 py-2 d-flex justify-content-between align-items-center" role="tab" v-d-toggle="'accordion-' + index">
                            <strong class="font-weight-bold">{{ application.application_name }}</strong><span class="text-primary">
                            <d-badge theme="danger" class="mr-2 circle-pill" pill v-if="!isApplicationCompleted(application)"><i class="fa fa-exclamation"></i></d-badge> Rozwiń</span>
                        </d-card-header>
                        <d-collapse :ref="'accordion-' + index" :id="'accordion-' + index" :accordion="'accordion-' + index" role="tabpanel" class="p-4">
                            <d-tabs>
                                <d-tab title="Pojazdy" class="pt-4" active v-if="application.application_type.toString() === '1'">
                                    <d-row>
                                        <d-col md="3" class="form-group"><ss-input v-model="application.car.model" name="model" placeholder="Marka"></ss-input></d-col>
                                        <d-col md="3" class="form-group"><ss-input v-model="application.car.register_number" name="register_number" placeholder="Numer rejestracyjny"></ss-input></d-col>
                                        <d-col md="2" class="form-group"><d-button theme="success" @click.prevent="addNewCar(application)"><i class="material-icons mr-1">add</i> Dodaj</d-button></d-col>
                                    </d-row>
                                    <table class="table mb-0 responsive-table">
                                        <thead class="bg-light">
                                        <tr>
                                            <th scope="col" class="border-0 id-cell">Dane pojazdu</th>
                                            <th scope="col" class="border-0 id-cell">Wycena</th>
                                            <th scope="col" class="border-0 id-cell">Licytacja</th>
                                            <th scope="col" class="border-0 id-cell">Akcja</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="car in application.cars" :key="'car-' + car.id">
                                            <td>
                                                <dt>Dane pojazdu</dt>
                                                <dd>
                                                    <p>
                                                        <strong class="font-weight-bold">Marka:</strong><br />
                                                        {{ car.model }}
                                                    </p>

                                                    <p>
                                                        <strong class="font-weight-bold">Numer rejestracyjny:</strong><br />
                                                        {{ car.register_number }}
                                                    </p>
                                                    <d-checkbox v-model="car.status" value="1" unchecked-value="0" @input="carChanged(car)" class="mt-2">Czy jest prowadzona egzekucja?</d-checkbox>
                                                </dd>
                                            </td>
                                            <td>
                                                <template v-if="car.status == '1'">
                                                    <dt>Wycena</dt>
                                                    <dd>
                                                        <d-checkbox v-model="car.valuation_commissioned" value="1" unchecked-value="0" @input="carChanged(car)" class="mt-2">Zlecono wycenę</d-checkbox>
                                                        <template v-if="car.valuation_commissioned == '1'">
                                                            <d-button @click.prevent="addExpense(car)" theme="success" v-if="!car.expense && car.id" class="mt-2"><i class="material-icons">add</i> Dodaj zaliczkę</d-button>
                                                            <template v-else>
                                                                <label class="mt-2 d-block">Wpłacono zaliczkę</label>
                                                                <div class="d-flex">
                                                                    <d-input readonly :value="car.expense.amount" class="w-100"></d-input>
                                                                    <d-button pill @click.prevent="editExpense(car.expense)" class="mr-0 mt-1 mb-1 ml-1 circle-pill pill"><i class="material-icons">edit</i></d-button>
                                                                    <d-button pill theme="danger"  class="mr-0 mt-1 mb-1 ml-1 circle-pill pill" @click.prevent="removeExpense(car.expense)"><i class="material-icons">delete</i></d-button>
                                                                </div>

                                                                <label class="d-block mt-2">Kwota wyceny</label>
                                                                <ss-price-input type="text"
                                                                                name="installment_fee"
                                                                                @blur="carChanged(car)"
                                                                                v-model="car.valuation_amount"/>
                                                            </template>
                                                        </template>
                                                    </dd>
                                                </template>
                                            </td>
                                            <td>
                                                <template v-if="car.status == '1'">
                                                    <dt>Licytacja</dt>
                                                    <dd>
                                                        <template>
                                                            <template v-if="car.sold_at_auction !== '-1'">
                                                                <d-checkbox v-model="car.request_for_auction" value="1" unchecked-value="0" @input="carChanged(car)">Złożono wniosek do sądu o wyznaczenie terminu licytacji</d-checkbox>
                                                                <template v-if="car.request_for_auction === '1'">
                                                                    <label class="mt-2 d-block">Data licytacji</label>
                                                                    <ss-date type="text"
                                                                             name="auction_date"
                                                                             class="text-left"
                                                                             v-model="car.auction_date"
                                                                             @input="carChanged(car)"
                                                                             placeholder=""/>
                                                                </template>
                                                            </template>
                                                            <template v-if="car.request_for_auction === '1' && car.auction_date">
                                                                <div class="d-flex mt-2 "><toggle-switch :group="car.id.toString()" :options="switchOptions" :value="car.sold_at_auction" @input="carChanged(car)" v-model="car.sold_at_auction" class="mr-2" /><span>Sprzedano na pierwszej licytacji</span></div>
                                                            </template>
                                                        </template>
                                                        <template v-if="car.sold_at_auction === '-1'">
                                                            <d-checkbox v-model="car.second_request_for_auction" value="1" unchecked-value="0" @input="carChanged(car)" class="mt-2">Złożono wniosek o drugą licytację</d-checkbox>
                                                            <template v-if="car.second_request_for_auction === '1'">
                                                                <label class="mt-2 d-block">Data drugiej licytacji</label>
                                                                <ss-date type="text"
                                                                         name="second_auction_date"
                                                                         class="text-left"
                                                                         v-model="car.second_auction_date"
                                                                         @input="carChanged(car)"
                                                                         placeholder=""/>
                                                                <d-checkbox v-model="car.second_sold_at_auction" value="1" unchecked-value="0" @input="carChanged(car)" class="mt-2" v-if="car.second_auction_date">Sprzedane na drugiej licytacji</d-checkbox>
                                                            </template>
                                                        </template>
                                                        <template v-if="car.sold_at_auction === '1' || car.second_sold_at_auction === '1'">
                                                            <label class="mt-2">Kwota z licytacji</label>
                                                            <ss-price-input type="text"
                                                                            name="auction_amount"
                                                                            @input="carChanged(car)"
                                                                            v-model="car.auction_amount"/>
                                                        </template>
                                                    </dd>
                                                </template>
                                            </td>
                                            <td>
                                                <dt>Akcja</dt>
                                                <dd class="wsnw">
                                                    <d-button @click.prevent="removeCar(car)" theme="danger"><i class="material-icons">delete</i> Usuń</d-button>
                                                </dd>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    <p v-if="!application.cars || application.cars.length < 1" class="text-info">Brak danych do wyświetlenia.</p>
                                </d-tab>
                                <d-tab active title="Księgi" class="pt-4" v-if="application.application_type.toString() === '2'">
                                    <d-row>
                                        <d-col md="3" class="form-group"><ss-input v-model="application.book.number" name="number" placeholder="Numer księgi wieczystej"></ss-input></d-col>
                                        <d-col md="2" class="form-group"><d-button theme="success" @click.prevent="addNewBook(application)"><i class="material-icons mr-1">add</i> Dodaj</d-button></d-col>
                                    </d-row>
                                    <table class="table mb-0 responsive-table">
                                        <thead class="bg-light">
                                        <tr>
                                            <th scope="col" class="border-0 id-cell">Dane księgi</th>
                                            <th scope="col" class="border-0 id-cell">Egzekucja</th>
                                            <th scope="col" class="border-0 id-cell">Licytacja</th>
                                            <th scope="col" class="border-0 id-cell">Akcja</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="book in application.books" :key="'book-' + book.id">
                                            <td>
                                                <dt>Dane księgi</dt>
                                                <dd>
                                                    <p>
                                                        <strong class="font-weight-bold">Numer księgi:</strong><br />
                                                        {{ book.number }}
                                                    </p>
                                                    <label class="mt-2">Komornik właściwy</label>
                                                    <d-radio v-model="book.can_do" value="1" @input="bookChanged(book)">tak</d-radio>
                                                    <d-radio v-model="book.can_do" value="0" @input="bookChanged(book)">nie</d-radio>
                                                    <template v-if="book.can_do === '0'">
                                                        <d-checkbox v-model="book.submit_application" value="1" unchecked-value="0" @input="bookChanged(book)" class="mt-2">Złożono wniosek o tytuł</d-checkbox>
                                                    </template>
                                                </dd>
                                            </td>
                                            <td>
                                                <dt>Egzekucja</dt>
                                                <dd v-if="book.can_do === '1'">
<!--                                                    <d-checkbox v-model="book.executions_ordered" value="1" unchecked-value="0" @input="bookChanged(book)">Zlecono egzekucję z nieruchomości</d-checkbox>-->
                                                    <template>
                                                        <d-checkbox v-model="book.valuation_commissioned" value="1" unchecked-value="0" @input="bookChanged(book)">Zlecono wycenę nieruchomośc</d-checkbox>
                                                        <template v-if="book.valuation_commissioned == '1'">
                                                            <d-button @click.prevent="addBookExpense(book)" theme="success" v-if="!book.expense && book.id" class="mt-2"><i class="material-icons">add</i> Dodaj zaliczkę</d-button>
                                                            <template v-else>
                                                                <label class="mt-2 d-block">Wpłacono zaliczkę</label>
                                                                <div class="d-flex">
                                                                    <d-input readonly :value="book.expense.amount" class="w-100"></d-input>
                                                                    <d-button pill @click.prevent="editExpense(book.expense)" class="mr-0 mt-1 mb-1 ml-1 circle-pill pill"><i class="material-icons">edit</i></d-button>
                                                                    <d-button pill theme="danger"  class="mr-0 mt-1 mb-1 ml-1 circle-pill pill" @click.prevent="removeExpense(book.expense)"><i class="material-icons">delete</i></d-button>
                                                                </div>
                                                            </template>

                                                            <ss-textarea v-model="book.expert_data" placeholder="Dane biegłego" label="Dane biegłego" @input="bookChanged(book)"></ss-textarea>

                                                            <label class="mt-2 d-block">Termin oględzin</label>
                                                            <ss-date type="text"
                                                                     name="inspection_date"
                                                                     class="text-left"
                                                                     v-model="book.inspection_date"
                                                                     @input="bookChanged(book)"
                                                                     placeholder=""/>

                                                            <template v-if="book.inspection_date">
                                                                <label class="mt-2">Kwota wyceny</label>
                                                                <ss-price-input type="text"
                                                                                name="valuation_amount"
                                                                                @input="bookChanged(book)"
                                                                                v-model="book.valuation_amount"/>

                                                            </template>

                                                            <d-checkbox v-model="book.description_commissioned" class="mt-2" value="1" unchecked-value="0" @input="bookChanged(book)">Zlecono opis i oszacowanie</d-checkbox>

                                                            <label class="mt-2 d-block">Data zlecenia opisu i oszacowania</label>
                                                            <ss-date type="text"
                                                                     name="description_date"
                                                                     class="text-left"
                                                                     v-model="book.description_date"
                                                                     @input="bookChanged(book)"
                                                                     placeholder=""/>

                                                            <label class="mt-2 d-block">Prawomocny opis i oszacowanie</label>
                                                            <ss-date type="text"
                                                                     name="final_description"
                                                                     class="text-left"
                                                                     v-model="book.final_description"
                                                                     @input="bookChanged(book)"
                                                                     placeholder=""/>
                                                        </template>
<!--                                                        <d-checkbox v-model="book.executions_in_book" value="1" unchecked-value="0" @input="bookChanged(book)">Zweryfikowano w KW czy istnieje wzmianka o egzekucji</d-checkbox>-->
                                                    </template>
                                                </dd>
                                                <dd v-else></dd>
                                            </td>
                                            <td>
                                                <dt>Licytacja</dt>
                                                <dd v-if="book.can_do === '1'">
                                                    <template>
                                                        <template v-if="book.sold_at_auction !== '-1' && book.description_date && book.final_description">
                                                            <d-checkbox v-model="book.request_made" value="1" unchecked-value="0" @input="bookChanged(book)">Złożono wniosek do sądu o wyznaczenie terminu licytacji</d-checkbox>
                                                            <template v-if="book.request_made === '1'">
                                                                <label class="mt-2 d-block">Data licytacji</label>
                                                                <ss-date type="text"
                                                                         name="auction_date"
                                                                         class="text-left"
                                                                         v-model="book.auction_date"
                                                                         @input="bookChanged(book)"
                                                                         placeholder=""/>
                                                            </template>
                                                        </template>
                                                        <template v-if="book.request_made === '1' && book.auction_date">
                                                            <div class="d-flex mt-2 "><toggle-switch :group="book.id.toString()" :options="switchOptions" :value="book.sold_at_auction" @input="bookChanged(book)" v-model="book.sold_at_auction" class="mr-2" /><span>Sprzedano na pierwszej licytacji</span></div>
                                                        </template>
                                                    </template>
                                                    <template v-if="book.sold_at_auction === '-1'">
                                                        <d-checkbox v-model="book.second_request_for_auction" value="1" unchecked-value="0" @input="bookChanged(book)" class="mt-2">Złożono wniosek o drugą licytację</d-checkbox>
                                                        <template v-if="book.second_request_for_auction === '1'">
                                                            <label class="mt-2 d-block">Data drugiej licytacji</label>
                                                            <ss-date type="text"
                                                                     name="second_auction_date"
                                                                     class="text-left"
                                                                     v-model="book.second_auction_date"
                                                                     @input="bookChanged(book)"
                                                                     placeholder=""/>
                                                            <d-checkbox v-model="book.second_sold_at_auction" value="1" unchecked-value="0" @input="bookChanged(book)" class="mt-2" v-if="book.second_auction_date">Sprzedane na drugiej licytacji</d-checkbox>
                                                        </template>
                                                    </template>
                                                    <template v-if="book.sold_at_auction === '1' || book.second_sold_at_auction === '1'">
                                                        <label class="mt-2">Kwota z licytacji</label>
                                                        <ss-price-input type="text"
                                                                        name="auction_amount"
                                                                        @input="bookChanged(book)"
                                                                        v-model="book.auction_amount"/>
                                                        <d-checkbox v-model="book.auction_nailing" value="1" unchecked-value="0" @input="bookChanged(book)" class="mt-2">Przybicie</d-checkbox>
                                                        <d-checkbox v-model="book.allocation_of_debt" value="1" unchecked-value="0" @input="bookChanged(book)" class="mt-2">Podział długu</d-checkbox>
                                                        <d-checkbox v-model="book.completed_property_enforcement" value="1" unchecked-value="0" @input="bookChanged(book)" class="mt-2">Zakończona egzekucja z nieruchomośc</d-checkbox>
                                                    </template>
                                                </dd>
                                                <dd v-else></dd>
                                            </td>
                                            <td>
                                                <dt>Akcja</dt>
                                                <dd>
                                                    <label>Status</label>
                                                    <d-select v-model="book.status" placeholder="Status" @input="bookChanged(book)" class="mb-2">
                                                        <option value="" selected>Status</option>
                                                        <option value="0">W trakcie</option>
                                                        <option value="1">Zakończona</option>
                                                    </d-select>
                                                    <d-button @click.prevent="" v-if="book.can_do === '0'" :disabled="!((book.can_do === '0' && book.submit_application === '1'))" class="w-100 mb-2"><i class="material-icons">list_alt</i> Rozpocznij sprawę u właściwego komornika</d-button>
                                                    <d-button @click.prevent="removeBook(book)" theme="danger" class="w-100"><i class="material-icons">delete</i> Usuń</d-button>
                                                </dd>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    <p v-if="!application.books || application.books.length < 1" class="text-info">Brak danych do wyświetlenia.</p>
                                </d-tab>
                                <d-tab title="Komentarz" :active="application.application_type === 0" class="pt-4">
                                    <fieldset class="form-group">
                                        <ss-textarea v-model="application.comment" label="Komentarz" name="comment" placeholder="Komentarz"></ss-textarea>
                                    </fieldset>
                                    <d-button @click.prevent="saveComment(application)">Zapisz</d-button>
                                </d-tab>
                                <d-tab title="Ponowne weryfikacje" class="pt-4">
                                    <d-row>
                                        <d-col md="3" class="form-group"><ss-date v-model="application.reverification.send_date" placeholder="Data wysyłki"></ss-date></d-col>
                                        <d-col md="3" class="form-group"><ss-input v-model="application.reverification.consignment_number" placeholder="Numer wysyłki"></ss-input></d-col>
                                        <d-col md="3" class="form-group"><d-button theme="success" @click.prevent="addNewReverification(application)"><i class="material-icons mr-1">add</i> Dodaj</d-button></d-col>
                                    </d-row>
                                    <table class="table mb-0 responsive-table">
                                        <thead class="bg-light">
                                        <tr>
                                            <th scope="col" class="border-0 id-cell">Data wysyłki</th>
                                            <th scope="col" class="border-0 id-cell">Numer wysyłki</th>
                                            <th scope="col" class="border-0 id-cell">Załatwione</th>
                                            <th scope="col" class="border-0 id-cell">Akcja</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="reverification in application.reverifications" :key="'reverifications-' + reverification.id">
                                            <td>
                                                <dt>Data wysyłki</dt>
                                                <dd>{{ reverification.send_date }}</dd>
                                            </td>
                                            <td>
                                                <dt>Numer wysyłki</dt>
                                                <dd>{{ reverification.consignment_number }}</dd>
                                            </td>
                                            <td>
                                                <dt>Załatwione</dt>
                                                <dd>
                                                    <d-checkbox v-model="reverification.status" value="1" unchecked-value="0" @input="reverificationChanged(reverification)">Tak</d-checkbox>
                                                </dd>
                                            </td>
                                            <td>
                                                <dt>Akcja</dt>
                                                <dd class="wsnw">
                                                    <d-button @click.prevent="removeReverification(reverification)" theme="danger"><i class="material-icons">delete</i> Usuń</d-button>
                                                </dd>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    <p v-if="!application.reverifications || application.reverifications.length < 1" class="text-info">Brak danych do wyświetlenia.</p>
                                </d-tab>

                                <d-tab title="Skargi" class="pt-4">
                                    <d-row>
                                        <d-col md="2" class="form-group"><ss-date :class="{'is-invalid' : lar_errors.has('date') }" @picked="lar_errors.clear('date')" v-model="application.complaint.date" name="date" placeholder="Data odwołania"></ss-date>
                                            <div class="invalid-feedback" :class="{'d-block': lar_errors.get('date')}" v-text="lar_errors.get('date')"></div></d-col>
                                        <d-col md="4" class="form-group"><ss-input v-model="application.complaint.comment" name="comment" placeholder="Komentarz"></ss-input></d-col>
                                        <d-col md="2" class="form-group"><d-select v-model="application.complaint.status" name="status" placeholder="Status">
                                            <option value="" selected>Status</option>
                                            <option value="0">W trakcie</option>
                                            <option value="1">Zakończona</option>
                                        </d-select></d-col>
                                        <d-col md="2" class="form-group"><d-button theme="success" @click.prevent="addNewComplaint(application)"><i class="material-icons mr-1">add</i> Dodaj</d-button></d-col>
                                    </d-row>
                                    <table class="table mb-0 responsive-table">
                                        <thead class="bg-light">
                                        <tr>
                                            <th scope="col" class="border-0 id-cell">Data odwołania</th>
                                            <th scope="col" class="border-0 id-cell">Komentarz</th>
                                            <th scope="col" class="border-0 id-cell">Status</th>
                                            <th scope="col" class="border-0 id-cell">Akcja</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="complaint in application.complaints" :key="'complaint-' + complaint.id">
                                            <td>
                                                <dt>Data odwołania</dt>
                                                <dd>{{ complaint.date }}</dd>
                                            </td>
                                            <td>
                                                <dt>Komentarz</dt>
                                                <dd>{{ complaint.comment }}</dd>
                                            </td>
                                            <td>
                                                <dt>Status</dt>
                                                <dd><d-select v-model="complaint.status" placeholder="Status" @input="complaintChanged(complaint)">
                                                    <option value="" selected>Status</option>
                                                    <option value="0">W trakcie</option>
                                                    <option value="1">Zakończona</option>
                                                </d-select></dd>
                                            </td>
                                            <td>
                                                <dt>Akcja</dt>
                                                <dd class="wsnw">
                                                    <d-button @click.prevent="removeComplaint(complaint)" theme="danger"><i class="material-icons">delete</i> Usuń</d-button>
                                                </dd>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    <p v-if="!application.complaints || application.complaints.length < 1" class="text-info">Brak danych do wyświetlenia.</p>
                                </d-tab>

                            </d-tabs>
                        </d-collapse>
                    </div>

                    <h5 class="mt-5">Przelewy od komornika ({{ toNumber(execution.contributions_sum) }} zł):</h5>
                    <d-row>
                        <d-col md="2" class="form-group"><ss-date v-model="case_payment.payment_date" placeholder="Data wpłaty"></ss-date></d-col>
                        <d-col md="2" class="form-group"><ss-price-input v-model="case_payment.amount" placeholder="Kwota"></ss-price-input></d-col>
                        <d-col md="4" class="form-group">
                            <v-select
                                    :options="execution.applications"
                                    v-model="case_payment.case_application_id"
                                    :reduce="element => element.id"
                                    placeholder="Powiąż z czynnością np. CEPIK"
                                    label="application_name">
                            <span slot="no-options">
                              Brak wyników
                            </span>
                            </v-select>
                        </d-col>
                        <d-col md="2" class="form-group"><d-button theme="success" @click.prevent="addPayment()"  :class="{ isLoading: adding_payment }"><i class="material-icons mr-1">add</i> Dodaj</d-button></d-col>
                    </d-row>
                    <table class="table mb-0 responsive-table">
                        <thead class="bg-light">
                        <tr>
                            <th scope="col" class="border-0 id-cell">Data wpłaty</th>
                            <th scope="col" class="border-0 id-cell">Kwota</th>
                            <th scope="col" class="border-0 id-cell">Czynność</th>
                            <th scope="col" class="border-0 id-cell">Akcja</th>
                        </tr>
                        </thead>
                        <tbody v-if="execution.contributions && execution.contributions.length > 0">
                        <tr v-for="payment in execution.contributions" :key="'contribution-' + payment.id">
                            <td>
                                <dt>Data wpłaty</dt>
                                <dd>{{ payment.paid_date}}</dd>
                            </td>
                            <td>
                                <dt>Kwota</dt>
                                <dd>{{ toNumber(payment.amount) }} zł</dd>
                            </td>
                            <td>
                                <dt>Czynność</dt>
                                <dd>{{ payment.application_name }}</dd>
                            </td>
                            <td>
                                <dt>Akcja</dt>
                                <dd class="wsnw">
                                    <d-button @click.prevent="removePayment(payment)" theme="danger"><i class="material-icons">delete</i> Usuń</d-button>
                                </dd>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <p v-if="execution.payments.length < 1" class="text-info">Brak wyników do wyświetlenia.</p>

                    <div class="flex-header mt-4">
                        <h5>Koszty sprawy </h5>
                        <d-button theme="success" @click.prevent="addExpense()"><i class="material-icons mr-1">add</i> Dodaj</d-button>
                    </div>

                    <table class="table mb-0 responsive-table" v-if="!fetching_expenses">
                        <thead class="bg-light">
                        <tr>
                            <th scope="col" class="border-0 id-cell">Imię i nazwisko</th>
                            <th scope="col" class="border-0 id-cell">Suma</th>
                            <th scope="col" class="border-0 id-cell">Typ kosztu</th>
                            <th scope="col" class="border-0 id-cell">Odbiorca</th>
                            <th scope="col" class="border-0 id-cell">Tytuł</th>
                            <th scope="col" class="border-0 id-cell">Komentarz</th>
                            <th scope="col" class="border-0 id-cell">Akcje</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(expense, index) in execution.expenses" :key="expense.id">
                            <td>
                                <dt>Imię i nazwisko</dt>
                                <dd>{{ expense.user.name }} {{ expense.user.surname }}</dd>
                            </td>
                            <td>
                                <dt>Suma</dt>
                                <dd>{{ toNumber(expense.amount) }} zł</dd>
                            </td>
                            <td>
                                <dt>Typ kosztu</dt>
                                <dd>{{ expense.expenses_cost_type_name }}</dd>
                            </td>
                            <td>
                                <dt>Odbiorca</dt>
                                <dd v-if="expense.expenses_cost_type === 1">{{ expense.bailiff_name }}</dd>
                                <dd v-else-if="expense.expenses_cost_type === 3">{{ expense.recipent }}</dd>
                                <dd v-else-if="expense.expenses_cost_type === 2">{{ expense.court_name }}</dd>
                            </td>
                            <td>
                                <dt>Tytuł</dt>
                                <dd>{{ expense.transfer_title }}</dd>
                            </td>
                            <td>
                                <dt>Komentarz</dt>
                                <dd>{{ expense.comment }}</dd>
                            </td>
                            <td>
                                <dt>Akcja</dt>
                                <dd class="wsnw">
                                    <d-button @click.prevent="editExpense(expense)" class="mr-2 mt-1 mb-1 ml-2"><i class="material-icons">edit</i> Edytuj</d-button>
                                    <d-button theme="danger"  class="mr-2 mt-1 mb-1 ml-2" @click.prevent="removeExpense(expense)"><i class="material-icons">delete</i> Usuń</d-button>
                                </dd>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <p v-if="execution.expenses.length < 1" class="text-info">Brak wydatków do wyświetlenia.</p>
                    <ss-pagination v-if="last_page > 1"
                                   @paginationChange="paginationChangeHandler"
                                   :current_page="current_page" :last_page="last_page" />
                </div>
            </transition>
        </d-list-group>
        <div v-if="fetched">
            <guarantor-modal v-if="execution && execution.guarantor && isObject(execution.guarantor)" :props="execution.guarantor" :show.sync="guarantor_modal"></guarantor-modal>
            <bailiff-modal v-if="bailiff" :props="bailiff" :show.sync="bailiff_modal"></bailiff-modal>
            <ss-modal
                    v-show="expense_modal"
                    title="Title"
                    v-if="expense"
                    intro="bounceIn"
                    outro ="bounceOut">
                <!-- HEADER -->
                <div slot = "modal-header">
                    Wydatek
                </div>
                <!-- BODY -->
                <div slot = "modal-body">
                    <expense-form :props="expense"></expense-form>
                </div>
                <!-- FOOTER -->
                <div slot = "modal-footer">
                    <d-button @click.prevent="closeExpense(expense)" theme="danger" class="mr-2">Zamknij</d-button>
                    <d-button @click.prevent="saveExpense(expense)" theme="success">Zapisz</d-button>
                </div>
            </ss-modal>
            <ss-modal
                    v-show="telephonesModal"
                    title="Telephone"
                    intro="bounceIn"
                    outro ="bounceOut">
                <!-- HEADER -->
                <div slot = "modal-header" style="display: flex;justify-content: space-between;align-items: center;width: 100%;">
                    <span>Numery telefonów</span>
                </div>
                <!-- BODY -->
                <div slot = "modal-body">
                    <table class="table">
                        <thead>
                        <tr>
                            <td>Numer telefonu</td>
                            <td>Opis</td>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(telephone, index) in execution.bailiff.telephones" :key="index">
                            <td>
                                <a :href="'tel:' + telephone.phone_number">
                                    {{ telephone.phone_number }}
                                </a>
                            </td>
                            <td>
                                {{ telephone.description }}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <!-- FOOTER -->
                <div slot = "modal-footer">
                    <d-button @click.prevent="telephonesModal = false" theme="danger">Zamknij</d-button>
                </div>
            </ss-modal>
            <ss-modal
                    class="xl"
                    v-if="newBailiffModal"
                    title="Title"
                    intro="bounceIn"
                    outro ="bounceOut">
                <div slot = "modal-header">
                    Dodawanie komornika
                </div>
                <div slot="modal-body">
                    <bailiff-form></bailiff-form>
                </div>
                <div slot = "modal-footer">
                    <d-button @click.prevent="newBailiffModal = false" theme="danger"><i class="material-icons">close</i> Anuluj</d-button>
                    <d-button @click.prevent="addNewBailiff" theme="success" class="ml-4"><i class="material-icons">save</i> Zapisz komornika</d-button>
                </div>
            </ss-modal>

        </div>
    </d-card-body>
</template>


<script>
  import LarErrors from '../../helpers/Errors'
  import SsDate from '../common/SsDate'
  import SsModal from '../common/SsModal'
  import SsPriceInput from '../common/SsPriceInput'
  import ExpenseForm from '../expense/ExpenseForm'
  import GuarantorModal from '../client/GuarantorModal'
  import BailiffModal from '../bailiffs/BailiffModal'
  import expenseUtil from '../../utils/expense'
  import ExecutionUtils from '../../utils/execution'
  import ToggleSwitch from '../common/SsToggleSwitch'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'ExecutionEdit',
    components: {
      SsDate,
      SsPriceInput,
      GuarantorModal,
      BailiffModal,
      SsModal,
      ExpenseForm,
      ToggleSwitch
    },
    props: {
      caseId: {
        reuiqred: true,
        type: Number
      },
      client: {
        default: () => {},
        type: Object
      },
      guarantors: {
        default: () => [],
        type: Array
      }
    },
    data(){
      return{
        switchOptions: {
          layout: {
            borderColor: '#eaeaea',
          },
          size: {
            fontSize: 0,
            height: 1.5,
            padding: 0,
            width: 4.5
          },
          items: {
            labels: [
              { name: '-1', color: 'white', backgroundColor: 'red' },
              { name: '0', color: 'white', backgroundColor: 'grey' },
              { name: '1', color: 'white', backgroundColor: 'green' }
            ]
          }
        },
        fetched: false,
        lar_errors: LarErrors,
        execution: _.clone(ExecutionUtils),
        newBailiffModal: false,
        adding_payment: false,
        determine: '0',
        adding_bailiff_payment: false,
        new_application: '',
        other_applications: false,
        expense_submitting: false,
        guarantor_modal: false,
        bailiff_modal: false,
        telephonesModal: false,
        expense_modal: false,
        fetching_expenses: false,
        submitting_form: false,
        expense: _.clone(expenseUtil),
        expenses: [],
        lang: {
          cash: 'Gotówka',
          transfer: 'Przelew'
        },
        case_payment: {
          payment_date: '',
          amount:  0,
          case_application_id: ''
        },
        bailiff_payment: {
          payment_date: '',
          amount: 0,
          comment: ''
        },
        last_page: 1,
        current_page: 1
      }
    },
    computed: {
      ...mapGetters([
        'allBailiffs',
        'allApplications',
        'getUser'
      ]),
      bailiff() {
        return this.allBailiffs.find(bailiff => bailiff.id === this.execution.bailiff_id)
      }
    },
    methods: {
      ...mapActions([
        'getAllBailiffs'
      ]),
      logMessage(msg) {
        console.log(msg)
      },
      isObject(obj) {
        return typeof obj === 'object' && !(obj instanceof Array)
      },
      toNumber(number) {
        return Vue.toNumber(number)
      },
      editExpense(expense) {
        this.expense = expense;
        this.expense_modal = true;
      },
      addNewBailiff() {
        this.$bus.$emit('new-bailiff-save')
      },
      addExpense(car){
        this.expense = _.clone(expenseUtil);
        this.expense.bailiff_id = this.execution.bailiff_id;
        this.expense.schedule_id = this.$route.params.schedule_id;
        this.expense.contract_case_id = this.$route.params.case_id;
        this.expense.expenses_cost_type = 3;

        if (car) {
          this.expense.car_id = car.id;
          this.expense.car = car;
          this.expense.expenses_cost_type = 1;
        }
        this.expense_modal = true
      },
      addBookExpense(book){
        this.expense = _.clone(expenseUtil);
        this.expense.bailiff_id = this.execution.bailiff_id;
        this.expense.schedule_id = this.$route.params.schedule_id;
        this.expense.contract_case_id = this.$route.params.case_id;
        this.expense.expenses_cost_type = 3;

        if (book) {
          this.expense.book_id = book.id;
          this.expense.book = book;
          this.expense.expenses_cost_type = 1;
        }
        this.expense_modal = true
      },
      saveExpense(){
          if(this.getUser.is_admin === 2){
              // User z dostepem tylko do odczytu nie moze robic update'a
              return;
          }
        const url = this.expense.id === '' ? 'api/expenses/store' : 'api/expenses/update/' + this.expense.id;
        this.expense_submitting = true;
        axios.post(url, this.expense).then(response => {
          Vue.swal({
            type: 'success',
            title: 'Wydatek został zapisany.',
            showConfirmButton: true,
          }).then(() => {
            this.expense_modal = false;
            this.fetchData(this.execution.id);
            this.$forceUpdate();
          });
          this.expense_submitting = false;
        }).catch((error) =>{
            Vue.swal({
                type: 'error',
                title: error.response.data.message,
                html: Vue.transformErrorsToHtml(error.response.data.errors),
                showConfirmButton: true,
            });
            this.expense_submitting = false;
            LarErrors.record(error.response.data.errors)
        })
      },
      closeExpense(){
        this.expense_modal = false
      },
      isApplicationCompleted(application){
        const {cars, books, reverifications, complaints, comment} = application;
        if (!comment) {
          return false
        }
        if (cars.length > 0) {
          const carsPending = cars.find(car => car.status.toString() === '0' || car.auction_date === '' || car.valuation_amount === '' || car.auction_amount.toString() === '0');
          if (carsPending) {
            return false
          }
        }
        if (books.length > 0) {
          const booksPending = books.find(book => book.status.toString() === '0' || book.can_do.toString() === '0' || book.submit_application.toString() === '0' || book.expert_data === '' || book.expert_data === '' || book.inspection_date === '' || book.valuation_amount.toString() === '0' || book.auction_date === '');
          if (booksPending) {
            return false
          }
        }
        if (reverifications.length > 0) {
          const reverificationsPending = reverifications.find(reverification => reverification.status.toString() === '0');
          if (reverificationsPending) {
            return false
          }
        }
        if (complaints.length > 0) {
          const complaintsPending = complaints.find(complaint => complaint.status.toString() === '0');
          if (complaintsPending) {
            return false
          }
        }
        return true
      },
      fetchData (id) {
        this.fetching_expenses = true;
        this.axios.post('api/contracts-case/get-case/' + id).then(response => {
            let execution = response.data;
            if (execution.applications) {
              execution.applications = execution.applications.map(application => {
                application.reverification = {
                  send_date: '',
                  consignment_number: ''
                };
                application.complaint = {
                  date: '',
                  comment: '',
                  status: ''
                };
                if (application.application_type.toString() === '1') {
                  application.car = {
                    model: '',
                    register_number: '',
                    status: '',
                    valuation_commissioned: '',
                    valuation_amount: '',
                    request_for_auction: '',
                    auction_date: '',
                    sold_at_auction: '',
                    auction_amount: ''
                  }
                }
                if (application.application_type.toString() === '2') {
                  application.book = {
                    number: '',
                    can_do: '',
                    submit_application: '',
                    status: '',
                    executions_ordered: 0,
                    executions_in_book: 0,
                    description_commissioned: 0,
                    expert_data: '',
                    inspection_date: '',
                    valuation_amount: 0,
                    request_made: 0,
                    auction_date: '',
                    sold_at_auction: 0,
                    auction_amount: 0,
                    auction_nailing: 0,
                    allocation_of_debt: 0,
                    description_date: '',
                    final_description: '',
                    completed_property_enforcement: 0
                  }
                }
                return application
              });
            }
            if (!execution.bailiff.name) {
              execution.bailiff_id = ''
            }
            this.execution = execution;

            this.expense.bailiff_id = this.execution.bailiff_id;

            this.$nextTick(function () {
              this.fetched = true;
              this.fetching_expenses = false;
              this.$forceUpdate();
            })
        })
      },
      removeExpense(expense){
          if(this.getUser.is_admin === 2){
              // User z dostepem tylko do odczytu nie moze robic update'a
              return;
          }
        Vue.swal({
          title: 'Uwaga',
          html: 'Czy potwierdzasz usunięcie wydatku?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Tak',
          cancelButtonText: 'Nie',
          buttonsStyling: true
        }).then((logout) => {
          if(logout.value){
            axios.post('api/expenses/delete/' + expense.id).then(response => {
              this.fetchData(this.execution.id)
            }).catch((errors) =>{
              console.log(errors);
            })
          }
        }).catch((errors) =>{
          console.log(errors);
        })
      },
      submitForm() {
          if(this.getUser.is_admin === 2){
              // User z dostepem tylko do odczytu nie moze robic update'a
              return;
          }
        this.submitting_form = true;
        this.axios.post('api/contracts-case/update-case/' + this.execution.id, this.execution).then(response => {
          this.submitting_form = false;
          Vue.swal({
            html: 'Zmiany zostały zapisane',
            type: 'success',
            buttonsStyling: true
          }).then(() => {
            this.fetchData(this.execution.id)
          });
        }).catch(error => {
          LarErrors.record(error.response.data.errors)
        })
      },
      completeApplications(applications) {
        if (!applications) {
          return []
        }
        const reducedApplications = applications.reduce((accumulator, application) => {
          if (application.status && application.status.toString() === '1') {
            return accumulator + 1
          }
          return accumulator
        }, 0);
        return reducedApplications
      },
      addNewReverification({id, reverification}) {
          if(this.getUser.is_admin === 2){
              // User z dostepem tylko do odczytu nie moze robic update'a
              return;
          }
        const {send_date, consignment_number} = reverification;
        this.axios.post('api/contracts-case-application/save-reverification', {
          send_date,
          consignment_number,
          case_application_id: id
        }).then(response => {
          Vue.swal({
            html: 'Ponowna weryfikacja zapisana',
            type: 'success',
            buttonsStyling: true
          });
          this.fetchData(this.execution.id)
        }).catch(error => {
          this.handleError(error)
        })
      },
      addNewCar({id, car}) {
          if(this.getUser.is_admin === 2){
              // User z dostepem tylko do odczytu nie moze robic update'a
              return;
          }
        this.axios.post('api/contracts-case-application/save-car', {
          ...car,
          case_application_id: id
        }).then(response => {
          Vue.swal({
            html: 'Pojazd zapisany',
            type: 'success',
            buttonsStyling: true
          });
          this.fetchData(this.execution.id)
        }).catch(error => {
          LarErrors.record(error.response.data.errors);
        })
      },
      addNewBook({id, book}) {
          if(this.getUser.is_admin === 2){
              // User z dostepem tylko do odczytu nie moze robic update'a
              return;
          }
        this.axios.post('api/contracts-case-application/save-book', {
          ...book,
          case_application_id: id
        }).then(response => {
          Vue.swal({
            html: 'Księga zapisana',
            type: 'success',
            buttonsStyling: true
          });
          this.fetchData(this.execution.id)
        }).catch(error => {
          LarErrors.record(error.response.data.errors);
        })
      },
      addNewComplaint({id, complaint}) {
          if(this.getUser.is_admin === 2){
              // User z dostepem tylko do odczytu nie moze robic update'a
              return;
          }
        const {date, comment, status} = complaint;
        this.axios.post('api/contracts-case-application/save-complaint', {
          date,
          comment,
          status,
          case_application_id: id
        }).then(response => {
          Vue.swal({
            html: 'Nowa skarga zapisana',
            type: 'success',
            buttonsStyling: true
          });
          this.fetchData(this.execution.id)
        }).catch(error => {
          LarErrors.record(error.response.data.errors);
        })
      },
      reverificationChanged(reverification) {
          if(this.getUser.is_admin === 2){
              // User z dostepem tylko do odczytu nie moze robic update'a
              return;
          }
        this.axios.post('api/contracts-case-application/save-reverification', reverification).catch(error => {
          this.handleError(error)
        })
      },
      applicationStatusChanged({id, status}) {
          if(this.getUser.is_admin === 2){
              // User z dostepem tylko do odczytu nie moze robic update'a
              return;
          }
        this.axios.post('api/contracts-case-application/change-status', {id, status}).catch(error => {
          this.handleError(error, () => {
            this.fetchData(this.execution.id)
          })
        })
      },
      carChanged(car) {
          if(this.getUser.is_admin === 2){
              // User z dostepem tylko do odczytu nie moze robic update'a
              return;
          }
        this.$forceUpdate();
        this.$nextTick(function () {
          this.axios.post('api/contracts-case-application/save-car', car).catch(error => {
            this.handleError(error)
          })
        })
      },
      bookChanged(book) {
        if(this.getUser.is_admin === 2){
            // User z dostepem tylko do odczytu nie moze robic update'a
            return;
        }
        this.$forceUpdate();
        this.$nextTick(function () {
          this.axios.post('api/contracts-case-application/save-book', book).catch(error => {
            this.handleError(error)
          })
        })
      },
      complaintChanged(complaint) {
          if(this.getUser.is_admin === 2){
              // User z dostepem tylko do odczytu nie moze robic update'a
              return;
          }
        this.axios.post('api/contracts-case-application/save-complaint', complaint).catch(error => {
          this.handleError(error)
        })
      },
      saveComment({ comment, id }) {
          if(this.getUser.is_admin === 2){
              // User z dostepem tylko do odczytu nie moze robic update'a
              return;
          }
        this.axios.post('api/contracts-case-application/save-comment', {
          comment,
          id
        }).then(response => {
          Vue.swal({
            html: 'Komentarz zapisany',
            type: 'success',
            buttonsStyling: true
          });
          console.log(response.data)
        }).catch(error => {
          this.handleError(error)
        })
      },
      addNewApplication() {
        if (!this.execution.new_applications) {
          this.execution.new_applications = []
        }
        this.execution.new_applications.push(this.new_application);
        this.new_application = '';
        this.$refs.newApplicationInput.$el.focus()
      },
      removeNewApplication(index) {
        this.execution.new_applications.splice(index, 1);
        this.$forceUpdate()
      },
      addPayment() {
          if(this.getUser.is_admin === 2){
              // User z dostepem tylko do odczytu nie moze robic update'a
              return;
          }
        if (!this.case_payment.payment_date || !this.case_payment.amount === 0 || !this.case_payment.case_application_id) {
          return Vue.swal({
            html: 'Uzupełnij wszystkie pola',
            type: 'warning',
            buttonsStyling: true
          })
        }
        this.adding_payment = true;
        this.axios.post('api/schedules/partial-payment', {
          amount: this.case_payment.amount,
          paid_date: this.case_payment.payment_date,
          schedule_id: this.$route.params.schedule_id,
          contract_case_id: this.execution.id,
          case_application_id: this.case_payment.case_application_id
        }).then(response => {
          this.case_payment.payment_date = '';
          this.case_payment.amount = 0;
          this.case_payment.case_application_id = null;
          this.fetchData(this.execution.id);
          this.adding_payment = false
        }).catch(error => {
          this.adding_payment = false;
          this.handleError(error)
        })
      },
      addBailiffPayment() {
          if(this.getUser.is_admin === 2){
              // User z dostepem tylko do odczytu nie moze robic update'a
              return;
          }
        if (!this.bailiff_payment.comment || !this.bailiff_payment.amount === 0 || !this.bailiff_payment.payment_date) {
          return Vue.swal({
            html: 'Uzupełnij wszystkie pola',
            type: 'warning',
            buttonsStyling: true
          })
        }
        this.adding_bailiff_payment = true;
        this.axios.post('api/contracts-case/add-payment', {
          ...this.bailiff_payment,
          contract_case_id: this.execution.id
        }).then(response => {
          this.adding_bailiff_payment = false;
          this.bailiff_payment.comment = '';
          this.bailiff_payment.amount = 0;
          this.bailiff_payment.payment_date = '';
          this.fetchData(this.execution.id)
        }).catch(error => {
          this.adding_bailiff_payment = false;
          this.handleError(error)
        })
      },
      handleError(error, callback) {
        LarErrors.record(error.response.data.errors);
        Vue.swal({
          html: error.response.data.error ? error.response.data.error : 'Wystąpił błąd. Spróbuj ponownie później.',
          type: 'warning',
          buttonsStyling: true
        }).then(() => {
          if (typeof callback === 'function') {
            callback()
          }
        })
      },
      handleRemoveSuccess() {
        Vue.swal({
          type: 'success',
          title: 'Rekord został usunięty.',
          showConfirmButton: true,
        }).then(() => {
          this.fetchData(this.execution.id)
        })
      },
      handleRemoval(url, options = {}) {
          if(this.getUser.is_admin === 2){
              // User z dostepem tylko do odczytu nie moze robic update'a
              return;
          }
        Vue.swal({
          title: 'Uwaga',
          html: options.html ? options.html : 'Czy potwierdzasz usunięcie?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Tak',
          cancelButtonText: 'Nie',
          buttonsStyling: true
        }).then((logout) => {
          if(logout.value){
            this.axios.post(url, options).then(response => {
              this.handleRemoveSuccess()
            }).catch((error) =>{
              this.handleError(error)
            })
          }
        }).catch((errors) =>{
          console.log(errors);
        })
      },
      removeReverification({id}) {
        this.handleRemoval('api/contracts-case-application/remove-reverification/' + id)
      },
      removeCar(car) {
        const id = car.id;
        let options= {};
        if(car.expense) {
          options.html = 'Czy jesteś pewny, że chcesz usunać pozycję? Usunięcie pojazdu spowoduje również usunięcie przypisanych do niego wydatków.'
        }
        this.handleRemoval('api/contracts-case-application/remove-car/' + id, options)
      },
      removeBook({id}) {
        this.handleRemoval('api/contracts-case-application/remove-book/' + id)
      },
      removeComplaint({id}) {
        this.handleRemoval('api/contracts-case-application/remove-complaint/' + id)
      },
      removePayment({id}){
        this.handleRemoval('api/delete-payment-history', { id })
      },
      removeBailiffPayment(payment){
        this.handleRemoval('api/contracts-case/remove-payment/' + payment.id)
      },
      newBailiffAdded(bailiff) {
        this.getAllBailiffs();
        this.newBailiffModal = false;
        this.execution.bailiff_id = bailiff.id
      }
    },
    mounted () {
      this.fetchData(this.caseId);
      this.$bus.$on('new-bailiff-saved', this.newBailiffAdded);
    },
    beforeDestroy () {
      this.$bus.$off('new-bailiff-saved', this.newBailiffAdded);
      this.execution.new_applications = []
    }
  }
</script>

<style lang="scss" scoped>
    .inline-data-row{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        min-height: 35px;
    }
    button.btn.circle-pill.pill.btn-pill {
        width: 34px;
        height: 34px;
        position: relative;
        i{
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
        }
    }
    h5{
        font-weight: bold;
        font-size: 18px;
    }
    .accordion-wrapper{
        border: 1px #000 solid;
    }
</style>
